
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Outlines_-_Full_Color","data-name":"Outlines - Full Color","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{attrs:{"fill":"none","d":"M42.87 46.9h156.42v163.35H42.87z"}})])]),_c('g',{staticClass:"cls-2",attrs:{"id":"Sprocket"}},[_c('path',{attrs:{"d":"M162.79 101.25V82a14.84 14.84 0 008.56-13.38v-.45a14.87 14.87 0 00-14.83-14.83h-.45a14.87 14.87 0 00-14.83 14.83v.45A14.84 14.84 0 00149.8 82v19.29a42.06 42.06 0 00-20 8.8L76.86 68.86a16.89 16.89 0 10-7.91 10.29L121 119.67a42.18 42.18 0 00.65 47.56l-15.84 15.84a13.6 13.6 0 00-3.93-.64 13.75 13.75 0 1013.75 13.75 13.56 13.56 0 00-.64-3.93l15.67-15.67a42.25 42.25 0 1032.1-75.33m-6.49 63.42A21.68 21.68 0 11178 143a21.68 21.68 0 01-21.68 21.68","fill":"#ff7a59"}})])])
          )
        }
      }
    